import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { SectionPager } from '../components/SectionPager';
import { Reveal } from '../components/Reveal';
import { domainFocus, education } from '../data/education';
export function Education() {
  return <>
      <PageHeader number="08" title="Education & Credentials" blurb="Purdue computer science, Pragmatic Institute, and Agile certification." data-id="element-223" data-mp="19uhfuqkn4qhq" />

      <section className="bg-paper py-20 lg:py-24" data-id="element-224" data-mp="zzz6p5wgg2qj">
        <div className="mx-auto max-w-shell px-6 lg:px-10" data-id="element-225" data-mp="vwjc0f3y4cgh">
          <ul data-id="element-226" data-mp="vz5gg5vjibuh">
            {education.map((entry, i) => <Reveal key={entry.institution} delay={Math.min(i * 0.05, 0.15)} data-id="element-227" data-mp="qyr9kr5od7y1" data-mpi={i}>
                <li className="grid gap-4 border-t border-navy/15 py-10 lg:grid-cols-12 lg:gap-16" data-id="element-228" data-mp="lzofg1r8gm4u">
                  <div className="lg:col-span-4" data-id="element-229" data-mp="2lc926skxsuzx">
                    <h2 className="font-display text-2xl font-light text-navy" data-id="element-230" data-mp="2l9wia9vmcak8">
                      {entry.institution}
                    </h2>
                    {entry.years && <p className="mt-2 text-[11px] uppercase tracking-overline text-steel" data-id="element-231" data-mp="1kb4g04wdc37m">
                        {entry.years}
                      </p>}
                  </div>
                  <div className="lg:col-span-8" data-id="element-232" data-mp="1ag2t7fpkfd87">
                    <p className="text-[13px] uppercase tracking-overline text-gold" data-id="element-233" data-mp="1fcjdfytn97g0">
                      {entry.credential}
                    </p>
                    {entry.detail && <ul className="mt-5 space-y-3" data-id="element-234" data-mp="282i7y9qlxws2">
                        {entry.detail.map(d => <li key={d} className="flex gap-3" data-id="element-235" data-mp="1tdvukdkjjf3h">
                            <span aria-hidden="true" className="mt-[11px] h-px w-4 shrink-0 bg-gold" data-id="element-236" data-mp="1tb9ko7a6gni3" />
                            <span className="text-[15px] leading-[1.7] text-steel" data-id="element-237" data-mp="2lzoqq4bbzvha">{d}</span>
                          </li>)}
                      </ul>}
                  </div>
                </li>
              </Reveal>)}
          </ul>
        </div>
      </section>

      <section className="border-t border-navy/10 bg-white py-16 lg:py-20" data-id="element-238" data-mp="2qqajemzsdlue">
        <div className="mx-auto grid max-w-shell gap-10 px-6 lg:grid-cols-12 lg:gap-16 lg:px-10" data-id="element-239" data-mp="2qsdirxmtwrbs">
          <div className="lg:col-span-4" data-id="element-240" data-mp="2mqryvsbvncs3">
            <Reveal data-id="element-241" data-mp="2hq47h5jqktxc">
              <p className="text-[11px] uppercase tracking-overline text-gold" data-id="element-242" data-mp="2hqe3b9rgpvay">Executive toolkit</p>
              <h2 className="mt-5 font-display text-3xl font-light leading-tight text-navy" data-id="element-243" data-mp="2cy44t5ca7mx2">
                Technical &amp; domain focus
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-8" data-id="element-244" data-mp="231rbi8knfb2u">
            <Reveal delay={0.06} data-id="element-245" data-mp="22yvdylcpqoex">
              <ul className="grid grid-cols-1 sm:grid-cols-2" data-id="element-246" data-mp="1yzmk7ghoaqjd">
                {domainFocus.map(d => <li key={d} className="border-t border-navy/10 py-4 font-display text-lg font-light text-navy sm:odd:pr-6 sm:even:border-l sm:even:border-navy/10 sm:even:pl-6" data-id="element-247" data-mp="1tzrv9ihgkb0y">
                    {d}
                  </li>)}
              </ul>
            </Reveal>
          </div>
        </div>
      </section>

      <SectionPager current="/education" data-id="element-248" data-mp="nia8kg5trq50" />
    </>;
}